import Button from './button';
import ButtonGroup from './button-group';
var DefaultButton = Button;
DefaultButton.Group = ButtonGroup;
export default DefaultButton;
//# sourceMappingURL=index.js.map